import {
    getGlobalSetting as getGlobalSettingAPI,
    editGlobalSetting as editGlobalSettingAPI,
    deleteGlobalSetting as deleteGlobalSettingAPI,
    editProjectTypeSetting as editProjectTypeSettingAPI,
    UpdateProjectType as UpdateProjectTypeAPI,
    exportAccountData as exportAccountDataAPI,
    checkAccountExportStatus as checkAccountExportStatusAPI,
    downloadAccountExport as downloadAccountExportAPI,
    importAccountData as importAccountDataAPI,
    checkAccountImportStatus as checkAccountImportStatusAPI
} from '../api/global-setting.api'
import { SAVE_PROJECT_CATEGORIES, FINANCE_TAX, LETTERHEAD } from '../constants/action.constant'
import idx from 'idx'

export const getGlobalSetting = (settingId) => {
    return (dispatch, getState) => {
        return getGlobalSettingAPI(settingId)
    }
}

export const editGlobalSetting = (settingData, settingId) => {
    return (dispatch, getState) => {
        return editGlobalSettingAPI(settingData, settingId)
    }
}

export const deleteGlobalSetting = (settingData, settingId) => {
    return (dispatch, getState) => {
        return deleteGlobalSettingAPI(settingData, settingId)
    }
}

export const editProjectTypeSetting = (settingData, settingId) => {
    return (dispatch, getState) => {
        return editProjectTypeSettingAPI(settingData, settingId)
    }
}

export const saveProjectCategory = data => ({ type: SAVE_PROJECT_CATEGORIES, data })

export const getProjectCategory = (data) => {
    return (dispatch, getState) => {
        return getGlobalSettingAPI(data).then((response) => {
            const projectCategoryData = idx(response, _response => _response);
            // Dispatch project categories
            dispatch(saveProjectCategory({ user: getState().user, projectCategory: projectCategoryData }))
            // Get final state after dispatch
            const finalState = getState();

            // Return comprehensive data
            return {
                apiResponse: response,
                projectCategoryData,
                finalProjectState: finalState.project,
                userState: finalState.user
            };
        }).catch((e) => {
            console.error('Get project category error:', e);
        })
    }
}

export const saveFinanceTax = data => ({ type: FINANCE_TAX, data })

export const saveLetterHead = data => ({ type: LETTERHEAD, data })

export const getGlobalSettingReducer = (type) => {
    return (dispatch, getState) => {
        return getGlobalSettingAPI(type).then((response) => {
            if (type === 'FINANCE_TAX')
                dispatch(saveFinanceTax(idx(response, _response => _response)))
            if (type === 'LETTERHEAD')
                dispatch(saveLetterHead(idx(response, _response => _response)))
        })
    }
}

export const UpdateProjectType = (settingData, settingId) => {
    return (dispatch, getState) => {
        return UpdateProjectTypeAPI(settingData, settingId)
    }
}

export const exportAccountData = (data) => {
    return (dispatch, getState) => {
        return exportAccountDataAPI(data)
    }
}

export const checkAccountExportStatus = (data) => {
    return (dispatch, getState) => {
        return checkAccountExportStatusAPI(data)
    }
}

export const downloadAccountExport = (data) => {
    return (dispatch, getState) => {
        return downloadAccountExportAPI(data)
    }
}

export const importAccountData = (file, accountId) => {
    return (dispatch, getState) => {
        return importAccountDataAPI(file, accountId)
    }
}

export const checkAccountImportStatus = (accountId) => {
    return (dispatch, getState) => {
        return checkAccountImportStatusAPI(accountId)
    }
}